import React from "react";
import styled from "styled-components/macro";
import { NavBarItemTextLinkProps } from "../types";

const StyledNavBarItemText = styled.a`
  color: #e6e6e6;
  height: 53px;
  text-align: center;
  font-size: var(--size-font-small);
  font-weight: var(--font-weight-regular);
  letter-spacing: normal;
  line-height: 53px;
  padding: 0px 16px;
  text-decoration: none;
  &:hover {
    background-color: #435360;
  }
`;

const NavBarItemTextLink = ({ value, route }: NavBarItemTextLinkProps) => (
  <StyledNavBarItemText data-testid="NavBarItemTextLink" href={route}>
    {value}
  </StyledNavBarItemText>
);

export default NavBarItemTextLink;
